import { createSelector } from "@ngrx/store";
import * as fromRoot from "#core/router-store";

import * as fromFeature from "../reducers";
import * as fromNotifications from "../reducers/notifications.reducers";
import * as selectorsHelperFn from "#helpers/selectors.helper";
import { Notification } from "cli-types";

// get notifications state
export const getNotificationsState = createSelector(
    fromFeature.getNotificationsModuleState,
    (state: fromFeature.NotificationsState) => state.notifications
);

// get the entities inside notifications state
export const getNotificationsEntities = createSelector(
    getNotificationsState,
    fromNotifications.getNotificationsEntities
);

// convert entities into array for frontend to consume
export const getAllNotifications = createSelector(
    getNotificationsEntities,
    (entities) => {
        return Array.from(entities.values());
    }
);

export const getSelectedMessage = createSelector(
    getNotificationsEntities,
    fromRoot.getRouterState,
    (entities, router): Notification | null => {
        return selectorsHelperFn.getSelectedEntity<Notification>(
            entities,
            router,
            "noticeID"
        );
    }
);

export const getNotificationsLoaded = createSelector(
    getNotificationsState,
    fromNotifications.getNotificationsLoaded
);

export const getNotificationsLoading = createSelector(
    getNotificationsState,
    fromNotifications.getNotificationsLoading
);

export const getAnnouncements = createSelector(
    getNotificationsState,
    fromNotifications.getAnnouncements
);

export const getPrivateMessages = createSelector(
    getNotificationsState,
    fromNotifications.getPrivateMessages
);

export const getMessagesTab = createSelector(
    getNotificationsState,
    fromNotifications.getMessagesTab
);

export const openMessagesPanel = createSelector(
    getNotificationsState,
    fromNotifications.openMessagesPanel
);
